import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fullMonthYear',
    standalone: false
})
export class FullMonthYearPipe implements PipeTransform {
  transform(value: Date): string {
    const monthNames = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];

    const month = monthNames[value.getMonth()];
    const year = value.getFullYear();

    return `${month} ${year}`;
  }
}
